<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="岗位计划管理" CMname="社会招聘岗位管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item label="计划：" prop="planId">
						<el-select v-model="searchform.planId" placeholder="请选择" >
							<el-option
								v-for="item in planIdData"
								:key="item.planId"
								:label="item.planName"
								:value="item.planId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
						      <el-option label="岗位名称" value="postTitle"></el-option>
						      <el-option label="专业" value="major"></el-option>
						      <el-option label="岗位简介" value="postInfo"></el-option>
						    </el-select>
						</el-input>
					</el-form-item>
					<el-form-item label="发布状态：" prop="public">
                        <el-select v-model="searchform.public" placeholder="请选择" >
                            <el-option label="全部" value=""></el-option>
                            <el-option label="已发布" :value="1"></el-option>
                            <el-option label="未发布" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')" >编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')" >删除</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left">
				</el-table-column>
				<el-table-column prop="postTitle" label="岗位名称" width="160" fixed="left" sortable>
				</el-table-column>
				<el-table-column prop="postInfo" label="岗位简介" width="220">
				</el-table-column>
				<el-table-column prop="planName" label="计划" width="220">
				</el-table-column>
				<el-table-column prop="orgName" label="部门" width="220" sortable >
				</el-table-column>
				<el-table-column prop="needNum" label="人数" width="60">
				</el-table-column>
				<el-table-column prop="major" label="专业" width="220">
				</el-table-column>
				<el-table-column prop="eucationTypeName" label="学历要求" width="110" sortable>
				</el-table-column>
				<el-table-column prop="diplomaTypeName" label="学位要求" width="120" sortable>
				</el-table-column>
				<el-table-column prop="oTitleTypeName" label="职称要求" width="110" sortable>
				</el-table-column>
				<el-table-column prop="oAgeTypeName" label="年龄要求" width="110" sortable>
				</el-table-column>
				<el-table-column prop="politicalType" label="政治面貌" width="110">
				</el-table-column>
				<el-table-column prop="other" label="其他条件" width="180">
				</el-table-column>
				<el-table-column prop="oFromType" label="招聘形式" width="110" sortable>
				</el-table-column>
				<el-table-column prop="oTimeDesc" label="招聘时间" width="180">
				</el-table-column>
				<el-table-column prop="oRangeType" label="招聘范围" width="220">
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="220">
				</el-table-column>
				<el-table-column prop="creationDate" label="创建时间" width="170" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="120">
				</el-table-column>
				<el-table-column prop="isPublic" label="发布情况" width="100" fixed="right">
					<template slot-scope="scope">
						{{scope.row.isPublic==true?"已发布":"未发布"}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="100" align="center" fixed="right" >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark"  placement="right" v-if="scope.row.logDesc">
                            <div slot="content" >{{scope.row.logDesc}}</div>
                            <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                            <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                            <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                            <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                        </el-tooltip>
                        <div v-else >
                        <el-tag  type="danger" disable-transitions v-if="scope.row.status==10" >{{scope.row.statusName}}</el-tag>
                        <el-tag  type="info" disable-transitions v-if="scope.row.status==-10" >{{scope.row.statusName}}</el-tag>
                        <el-tag  type="primary" disable-transitions v-if="scope.row.status==0">{{scope.row.statusName}}</el-tag>
                        <el-tag  type="success" disable-transitions v-if="scope.row.status==20" >{{scope.row.statusName}}</el-tag>
                        </div>
                    </template>
                </el-table-column>
				<el-table-column label="操作" width="130" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small" v-if="isHadFun('Update')">编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small" v-if="isHadFun('Delete')">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'plan_open',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:10,
					postType:2,
					planId:"",
					postTitle:"",
					postInfo:"",
					major:"",
					public:""
				},
				tableData:[],
				planIdData:[],
				total:0,
				loading:true,
				selectionRows:[],
				selectfield:"postTitle",
				keyword:"",
			}
		},
		methods:{
			onSubmit(){
				this.searchform.postTitle="";
				this.searchform.postInfo="";
				this.searchform.major="";
				this.searchform[this.selectfield]=this.keyword;
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Rowview(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/plan/open/view/'+val.postId});
			},
			RowEdit(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/plan/open/edit/'+val.postId});
			},
			Rowdelete(val){

				this.$confirm("确定要删除 '"+val.postTitle+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios.post(this.$api.plan.postDel,{postId:val.postId})
					.then((response)=>{
						var redata=response.data;
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			RowPublic(val){

			},
			Addclick(){
				this.$router.push({path:'/plan/open/add/',});
			},
			pubclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}

			},
			editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message({message:"只能操作一行数据",type:"warning"});
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/plan/open/edit/'+this.selectionRows[0].postId});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios.post(this.$api.plan.postDel,{postId:myrow.postId});
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			cellclick(row, column, cell, event){
				this.$refs.Opentable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			initData(){
				var Vuethis=this;
				this.loading=true;
				this.$hrraxios.get(this.$api.plan.postList, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.success==true)
					{
						Vuethis.tableData=data.data.list;
						Vuethis.total=data.data.total;
					}else{
						Vuethis.$message.error(data.prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			},
			initParamsData(){
				this.$common.getplanlist(this,"planIdData");
				this.$common.getFunListByMCode(this,"PlanOpen");
			}
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			next();
		},
		created(){
			this.initData();
			this.initParamsData();
		}
	}
</script>
<style >
  .input-with-select { width: 110px;}
</style>
